export const inputDataList = (startDate: string, endDate: string) => [
  {
    label: "から",
    value: startDate,
    onChangeValue: "start",
  },
  {
    label: "まで",
    value: endDate,
    onChangeValue: "end",
  },
];
